<template>
	<div class="content-box">
		<!-- banner -->
		<div class="banner">
			<div class="banner_title">
				<div style="display: flex;justify-content: space-between;height: 50px;align-items: center;">
					<img src="../../assets/image/logo.png" style="width: 144px;height: 27px;" />
					<div style="color: #ffffff;">
						<div style="font-size: 18px;letter-spacing: 6px;margin: 0;text-align: left;font-family: MicrosoftYaHei-Bold;">国家信息安全漏洞共享平台</div>
						<div style="margin-top: -5px;font-size: 13px;text-align: left;font-family: MicrosoftYaHei-Bold;">CHINA NATIONAL VULNERABILITY DATABASE</div>
					</div>
				</div>
				<div style="color: #fff;font-size: 54px;font-family: MicrosoftYaHei-Bold;
    letter-spacing: 10px;
    font-weight: bold;
">工控漏洞子库</div>
			</div>
			<!-- <div class="banner-img">
				<img src="../../assets/image/banner/icon.png" />
			</div> -->
		</div>

		<!-- 数量统计 -->
		<div class="quantity-statistics-box">
			<div class="width-1200">
				<div class="number-list" @click="jumpListAll()">
					<div>
						<p class="number-name">漏洞总数</p>
						<p class="num-total" style="color: #000000;">{{this.vulnerabilityInfos.total}}</p>
					</div>
				</div>
				<div class="number-list" @click="jumpList(1)">
					<p class="number-name">高危漏洞</p>
					<p class="num-total" style="color: #f34f4e;">{{this.vulnerabilityInfos.high}}</p>
				</div>
				<div class="number-list" @click="jumpList(2)">
					<p class="number-name">中危漏洞</p>
					<p class="num-total" style="color: #eebd34;">{{this.vulnerabilityInfos.middle}}</p>
				</div>
				<div class="number-list1" @click="jumpList(3)">
					<p class="number-name">低危漏洞</p>
					<p class="num-total" style="color: #009ef3;">{{this.vulnerabilityInfos.low}}</p>
				</div>
			</div>
		</div>

		<!-- tab+hot -->
		<div class="tab-hot">
			<div class="width-1200-m">
				<!-- tab -->
				<div class="tab-box">
					<p class="seeMore" style="font-size: 12px;font-weight: 400;color: #999;line-height: 40px;cursor: pointer;position: absolute;right: 8px;z-index: 1000"
					 @click="pushRoute">
						查看更多
						<!-- <img src="../../assets/image/icon/more.png" style="width: 14px;height: 14px;" /> -->
					</p>
					<a-tabs default-active-key="1" @change="callback">
						<a-tab-pane key="1" tab="最新漏洞">
							<div style="width: 100%;background: #fff;padding: 0px 0 35px 0;">
								<div style="border-bottom: 1px solid #ccc;padding-bottom: 20px;padding-top: 30px" v-for="(item,i) in this.newsInfo"
								 :key="i">
									<p class="oh" ref="dataid" @click="pushPath(item.id)" style="display: flex;align-items: center;">
										<!-- {{item.vulClass}} -->
										<img v-if="item.grade == 3" src="../../assets/image/icon/high.png" style="width: 28px;height: 4px;margin-right: 12px;" />
										<img v-if="item.grade == 2" src="../../assets/image/icon/middle.png" style="width: 28px;height: 4px;margin-right: 12px;" />
										<img v-if="item.grade == 1" src="../../assets/image/icon/low.png" style="width: 28px;height: 4px;margin-right: 12px;" />
										<span class="info_title fl">
											{{item.title}}
										</span>
										<span class="info_time fr">
											{{item.publicDate.split(' ')[0]}}
										</span>
									</p>
									<p class="info_summary" style="text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;line-clamp: 1;-webkit-box-orient: vertical;">
										{{item.description}}
									</p>
								</div>
							</div>
						</a-tab-pane>
<!--						<a-tab-pane key="2" tab="热点事件">-->
<!--							<div style="width: 100%;background: #fff;padding: 6px 16px 30px 23px;">-->
<!--								<div style="border-bottom: 1px solid #ccc;padding-bottom: 20px;" v-for='(item,i) in this.hotCon' :key="i">-->
<!--									<p class="oh" @click="pushPathHot(item.id)" style="padding-top: 20px;">-->
<!--										<span class="info_title fl">-->
<!--											{{item.title}}-->
<!--										</span>-->
<!--										<span class="info_time fr">-->
<!--											{{item.publishTime.split(' ')[0]}}-->
<!--										</span>-->
<!--									</p>-->
<!--									<p class="info_summary" style="text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;line-clamp: 1;-webkit-box-orient: vertical;">-->
<!--										{{item.summary}}-->
<!--									</p>-->
<!--								</div>-->

<!--							</div>-->
<!--						</a-tab-pane>-->
<!--						<a-tab-pane key="3" tab="最新公告">-->
<!--							<div style="width: 100%;background: #fff;padding: 6px 16px 35px 23px;">-->
<!--								<div style="border-bottom: 1px solid #ccc;padding-bottom: 20px;" v-for='(item,i) in this.anquan' :key="i">-->
<!--									<p class="oh" @click="pushPathNot(item.id)" style="padding-top: 20px;">-->
<!--										<span class="info_title fl">-->
<!--											{{item.title}}-->
<!--										</span>-->
<!--										<span class="info_time fr">-->
<!--											{{item.publishTime.split(' ')[0]}}-->
<!--										</span>-->
<!--									</p>-->
<!--									<p class="info_summary" style="text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;line-clamp: 1;-webkit-box-orient: vertical;">-->
<!--										{{item.summary}}-->
<!--									</p>-->
<!--								</div>-->

<!--							</div>-->
<!--						</a-tab-pane>-->
					</a-tabs>
				</div>
				<!-- hot -->
				<div class="hot-box">
					<div class="search-submit">
						<router-link to="/bugList">
							<div class="search-box">
								<div class="center-nr">
									<img src="../../assets/image/icon/search.png" />
									<span>漏洞查询</span>
								</div>
							</div>
						</router-link>
						<div class="submit-box" @click="See">
							<div class="center-nr">
								<img src="../../assets/image/icon/submit.png" style="width: 20px;margin-right: 15px;" />
								<span>漏洞提交</span>
							</div>
						</div>
					</div>

					<div class="hot_title">
						<img src="../../assets/image/icon/hot.png" />
						<span>热门漏洞</span>
					</div>

					<div>
						<a-row style="padding: 0 27px 15px 23px;background: #f7f8fa;" class="rightBoxMsg">
							<a-col>
								<a-row>
									<p style="cursor: pointer;text-align: left;height: 50px;font-size: 14px;line-height: 50px;font-weight: 400;color: #999;border-bottom: 1px dashed #ccc;cursor: pointer;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
									 v-for="(item,i) in this.hotInfo" :data-id="item.id" @click="pushPath(item.id)" :key="i">
										<a-icon type="caret-right" style="margin-right: 3px" />
										<span class="listLi">
											{{item.title}}
										</span>
									</p>
								</a-row>
							</a-col>
						</a-row>
					</div>
				</div>
			</div>
		</div>

		<div class="echarts-box">
			<div class="width-1200-e">
				<div class="echarts_title">漏洞态势</div>
				<div class="echarts_c">
					<div class="echarts-line">
						<div class="line_title">
							<img src="../../assets/image/icon/line.png" style="width: 14px;height: 11px;margin-right: 8px;" />
							<span>近一年新增漏洞趋势</span>
						</div>
						<div id="echartLine" style="100%;height: 100%;"></div>
					</div>
					<div class="echarts-pie">
						<div class="pie_title">
							<img src="../../assets/image/icon/pie.png" style="width: 14px;height: 14px;margin-right: 8px;" />
							<span>漏洞危害等级分布</span>
						</div>
						<div id="echartsPieTwo" style="100%;height: 100%;"></div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import moment from 'moment'
	import echarts from 'echarts'
	import {
		getCountNumber,
		getNew,
		getHotBug,
		getBugLine,
		getBugPie,
		getBugPieTwo,
		getHotMsg
	} from '../../api/index'
	export default {
		name: "index",
		data() {
			return {
				// 判断查看更多
				tabKey: 1,
				// 漏洞数量
				vulnerabilityInfos: {},
				// 最新漏洞
				newsInfo: [],
				// 热门漏洞
				hotInfo: [],
				// 热点推荐
				hotCon: [],
				// 安全公告
				anquan: [],
				// 折线图数据
				lineDataName: [],
				lineDataValue: [],
				// 影响对象统计
				bugPie: [],
				// 危险等级分布
				bugDanger: [],
			}
		},
		filters: {
			formatDate: function(value) {
				return moment(value).format('YYYY-MM-DD')
			}
		},
		methods: {
			/**=============跳转到漏洞列表页面的方法================== */
			//漏洞总数跳转
			jumpListAll() {
				this.$router.push({
					name: 'bugList'
				})
			},
			jumpList(val) {
				if (val === 1) {
					this.$router.push({
						name: 'bugList',
						params: {
							i: val,
							value: 3
						}
					})
				} else if (val === 2) {
					this.$router.push({
						name: 'bugList',
						params: {
							i: val,
							value: 2
						}
					})
				} else if (val === 3) {
					this.$router.push({
						name: 'bugList',
						params: {
							i: val,
							value: 1
						}
					})
				}

			},
			See(e) {
				window.location.href = 'https://www.cnvd.org.cn/user/login'
			},
			callback(key) {
				this.tabKey = key
			},
			// 跳转查看更多
			pushRoute() {
				if (this.tabKey == 1) {
					this.$router.push({
						name: 'bugList'
					})
				} else if (this.tabKey == 2) {
					this.$router.push({
						name: 'hotMsg'
					})
				} else {
					this.$router.push({
						name: 'notice'
					})
				}
			},
			// 日期转换
			getdate(time) {
				var now = new Date(parseInt(time)),
					y = now.getFullYear(),
					m = now.getMonth() + 1,
					d = now.getDate();
				return y + '-' + m + '-' + d
			},
			// 获取漏洞数量
			getCount() {
				getCountNumber().then(res => {
					if (res.status == 200) {
						this.vulnerabilityInfos = res.data
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 获取热点推荐
			getHotCon() {
				var params = {
					type: 0
				}
				getHotMsg(params).then(res => {
					if (res.status == 200) {
						var data = res.data.page.records
						for (var i = 0; i < data.length; i++) {
							data[i].publishTime = this.dateUtil.dateFormat(data[i].publishTime)
						}
						this.hotCon = data
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 获取安全公告
			getMsg() {
				var params = {
					type: 2
				}
				getHotMsg(params).then(res => {
					if (res.status == 200) {
						var data = res.data.page.records
						for (var i = 0; i < data.length; i++) {
							data[i].publishTime = this.dateUtil.dateFormat(data[i].publishTime)
						}
						this.anquan = data
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 获取最新漏洞
			getNews() {
				getNew().then(res => {
					if (res.status == 200) {
						this.newsInfo = res.data.page.records
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 获取热门漏洞
			getHot() {
				getHotBug().then(res => {
					if (res.status == 200) {

						this.hotInfo = res.data.page.records
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})
			},
			// 影响对象类型统计
			echartsPie() {
				getBugPie().then(res => {
					if (res.status == 200) {
						this.bugPie.push({
							name: '工控系统',
							value: res.data.industrialControl
						}, )
						var dom = document.getElementById('echartsPie')
						var myChart = this.echarts.init(dom)
						var colorList = ['#3098f5', '#73ACFF', '#FDD56A', '#FDB36A', '#FD866A', '#9E87FF', '#58D5FF']
						myChart.setOption({
							color: colorList,
							title: [{
								text: '漏洞总数',
								x: 'center',
								top: '40%',
								textStyle: {
									color: '#333',
									fontSize: 16,
								}
							}, {
								text: res.data.total,
								x: 'center',
								top: '50%',
								textStyle: {
									fontSize: '22',
									color: '#333',
									foontWeight: '100',
								},
							}],
							legend: {
								orient: 'horizontal',
								bottom: '5%',
								data: this.bugPie,
								textStyle: {
									color: "#333",
									fontSize: 12
								}
							},
							tooltip: {
								trigger: 'item'
							},
							series: [{
								type: 'pie',
								center: ['50%', '50%'],
								radius: ['36%', '50%'],
								clockwise: true,
								avoidLabelOverlap: true,
								hoverOffset: 15,
								itemStyle: {
									normal: {
										color: function(params) {
											return colorList[params.dataIndex]
										}
									}
								},
								label: {
									show: true,
									position: 'outside',
									formatter: '{a|{b}:{d}%}\n{hr|}',
									rich: {
										hr: {
											backgroundColor: 't',
											borderRadius: 3,
											width: 3,
											height: 3,
											padding: [3, 3, 0, -12]
										},
										a: {
											padding: [-30, 15, -20, 15]
										}
									}
								},
								labelLine: {
									normal: {
										length: 10,
										length2: 10,
										lineStyle: {
											width: 1
										}
									}
								},
								data: this.bugPie,
							}]
						})
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}

				})

			},
			// 危险等级分布
			echartsPieTwo() {
				getBugPieTwo().then(res => {
					if (res.status == 200) {
						const bugDanger = [];
						bugDanger.push({
								value: res.data.high,
								name: '高危'
							}, {
								value: res.data.middle,
								name: '中危'
							}, {
								value: res.data.low,
								name: '低危'
							},
							// {value:res.data.unknown, name:'未知'}
						)
						var dom = document.getElementById('echartsPieTwo')
						var myChart = this.echarts.init(dom)
						myChart.setOption({
							tooltip: {
								trigger: 'item',
								formatter: "{a} <br/>{b} : {c} ({d}%)"
							},
							color: ['#f34f4e', '#eebd34', '#009ef3', '#43d496'],
							legend: {
								// selectedMode: false, // 取消图例上的点击事件
								type: 'plain',
								icon: 'circle',
								orient: 'vertical',
								right: '20%',
								top: '40%',
								align: 'left',
								itemGap: 15,
								itemWidth: 10, // 设置宽度
								itemHeight: 10, // 设置高度
								textStyle: {
									color: '#000',
								},
								data: bugDanger.map(item => item.name),
								formatter: function(name) {
									if (bugDanger && bugDanger.length) {
										for (var i = 0; i < bugDanger.length; i++) {
											if (name === bugDanger[i].name) {
												return (
													name +
													'    '+
													bugDanger[i].value +
													''
												)
											}
										}
									}
								}
							},
							series: [{
								name: '危险等级',
								type: 'pie',
								center: ['30%', '50%'],
								radius: ['50%', '80%'],
								data: bugDanger,
								itemStyle: {
									emphasis: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									}
								},
								itemStyle: {
									normal: {
										label: {
											show: false,
											formatter: '{b}:{c}\n({d}%)'
										}
									},
									labelLine: {
										show: true,
										normal: {
											length: 10,
											length2: 10,
											lineStyle: {
												width: 1
											}
										}
									}
								}
							}]
						})
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})

			},
			// 近10个月漏洞趋势
			echartsLine() {
				getBugLine().then(res => {
					if (res.status == 200) {
						var dom = document.getElementById('echartLine');
						var myChart = this.echarts.init(dom);
						for (var i = 0; i < res.data.length; i++) {
							this.lineDataName.push(res.data[i].month)
							this.lineDataValue.push(res.data[i].count)
						}
						myChart.setOption({
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									lineStyle: {
										color: '#ddd'
									}
								},
								padding: [5, 10],
							},
							grid: {
								top: "20px",
								left: "40px",
								right: "30px",
								bottom: "25px"
							},
							xAxis: {
								type: 'category',
								name: '',
								data: this.lineDataName,
								boundaryGap: false,
								splitLine: {
									show: false,
									interval: 'auto',
									lineStyle: {
										color: ['#D4DFF5']
									}
								},
								axisTick: {
									show: true
								},
								axisLine: {
									lineStyle: {
										color: '#999'
									}
								},
								// axisLabel: {
								// 	rotate: 40,
								// 	interval: 0,
								// 	color: '#000000',
								// 	fontSize:'12'
								// }
								axisLabel: {
									margin: 10,
									textStyle: {
										fontSize: 10
									}
								}
							},
							yAxis: {
								type: 'value',
								name: '',
								splitLine: {
									lineStyle: {
										color: ['#ccc']
									}
								},
								axisTick: {
									show: true
								},
								axisLine: {
									lineStyle: {
										color: '#999'
									}
								},
								axisLabel: {
									margin: 10,
									textStyle: {
										fontSize: 12
									}
								}
							},
							series: [{

								type: 'line',
								smooth: false,
								showSymbol: false,
								symbol: 'circle',
								symbolSize: 2,
								data: this.lineDataValue,
								//渐变
								areaStyle: {
									normal: {
										color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
												offset: 0,
												color: '#acdffb'
											},
											{
												offset: 1,
												color: '#fefeff'
											}
										], false),
										shadowColor: 'rgba(195,230,255,0.1)',
										shadowBlur: 20
									}
								},
								itemStyle: {
									normal: {
										color: '#58c8da'
									}
								},
								lineStyle: {
									normal: {
										width: 2,
										color: '#64c4f7'
									}
								}
							}]
						})
					} else if (res.status == 504) {
						this.$message.warning(res.msg);
					} else {
						this.$message.warning(res.msg);
					}
				})

			},
			// 跳转漏洞详情
			pushPath(id) {
				this.$router.push({
					name: 'bugInfo',
					params: {
						key: id
					}
				})
			},
			// 跳转热点推荐详情
			pushPathHot(id) {
				this.$router.push({
					name: 'hotInfo',
					params: {
						key: id
					}
				})
			},
			// 跳转公告
			pushPathNot(id) {
				this.$router.push({
					name: 'noticeInfo',
					params: {
						key: id
					}
				})
			},
		},
		mounted() {
			this.getCount();
			this.getNews()
			this.getHot()
			this.getMsg();
			this.getHotCon();
			//echarts图
			// this.echartsPie()
			this.echartsPieTwo()
			this.echartsLine();;
		}
	}
</script>

<style scoped>
	.content-box {
		width: 100%;
		background-color: #ffffff;
	}

	.banner {
		width: 100%;
		height: 290px;
		background: url("../../assets/image/banner/index.png") center center no-repeat;
		background-size: cover;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.banner_title{
		width: 460px;
		height: 117px;
	}

	.banner-img {
		margin: 0 auto;
		width: 24%;
		display: flex;
		align-items: center;
		height: 290px;
		/* height: 100px; */
	}

	.banner-img img {
		width: 100%;
		height: auto;
		align-items: center;
	}

	img {
		width: 100%;
	}

	p {
		margin-bottom: 0px;
	}

	/* common */
	.width-1200 {
		height: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}

	.width-1200-m {
		height: 100%;
		display: flex;
		justify-content: space-between;
	}

	/* 数量统计 */
	.quantity-statistics-box {
		width: 100%;
		height: 116px;
		background-color: #f7f8fa;
	}

	.number-list {
		width: 364px;
		height: 81%;
		border-left: 1px solid #e8e8e8;
		padding-left: 20px;
		cursor: pointer;
	}
	.number-list1{
		width: 108px;
		height: 81%;
		border-left: 1px solid #e8e8e8;
		padding-left: 20px;
		cursor: pointer;
	}

	.number-name {
		font-size: 14px;
		color: #333333;
		text-align: left;
		font-family: "PingFangSC-Regular";
		/* margin-bottom: 16px; */
	}

	.num-total {
		font-size: 42px;
		color: #000000;
		text-align: left;
		font-family: "DIN-Medium";
	}

	/* tab-hot */
	.tab-hot {
		width: 100%;
		margin-top: 15px;
		text-align: left;
	}

	.tab-box {
		width: 830px;
		position: relative;
	}
	/deep/ .ant-tabs-bar{
		margin: 0;
	}

	.hot-box {
		width: 350px;
		margin-top: 13px;
	}

	.search-submit {
		width: 100%;
		height: 46px;
		display: flex;
		justify-content: space-between;
	}

	.search-box {
		width: 165px;
		height: 46px;
		background-color: #009ef3;
		border-radius: 6px;
	}
	.search-box:hover{
		background-color: #0391dd;
	}

	.submit-box {
		width: 165px;
		height: 46px;
		background-color: #f34f4e;
		border-radius: 6px;
		cursor: pointer;
	}
	.submit-box:hover{
		background-color: #e74443;
	}

	.center-nr {
		width: 63%;
		height: 100%;
		margin: 0 auto;
		display: flex;
		align-items: center;
	}

	.center-nr img {
		width: 25px;
		height: 25px;
		display: inline-block;
		margin-right: 9px;
	}

	.center-nr span {
		display: inline-block;
		color: #fff;
		font-size: 16px;
		font-family: "PingFangSC-Medium";
		line-height: 46px;
	}

	.hot_title {
		margin: 30px 0 14px 0;
		width: 100%;
		/* height: 25px;
		line-height: 25px; */
	}

	.hot_title img {
		display: inline-block;
		width: 12px;
		height: 14px;
		margin-right: 8px;
		margin-top: -3px;
	}

	.hot_title span {
		display: inline-block;
		font-size: 14px;
		color: #181818;
		font-family: "PingFangSC-Medium";
	}

	/* echarts-box */
	.echarts-box {
		width: 100%;
		margin: 0 0 50px;
	}

	.width-1200-e {
		width: 1200px;
		margin: 0 auto;
	}

	.echarts_title {
		width: 100%;
		height: 50px;
		line-height: 50px;
		text-align: center;
		background-image: linear-gradient(to right, #058ed8, #0774af);
		color: #fff;
		font-size: 16px;
		font-weight: bold;
		letter-spacing: 2px;
		font-family: "PingFangSC-Medium";
	}

	.echarts_c {
		width: 100%;
		height: 280px;
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
	}

	.echarts-line {
		width: 720px;
		height: 250px;
	}

	.echarts-pie {
		width: 454px;
		height: 250px;
	}

	.line_title,
	.pie_title {
		text-align: left;
		font-size: 14px;
		font-weight: bold;
		height: 30px;
		line-height: 30px;
	}

	.line_title img,
	.pie_title img {
		margin-right: 5px;
	}





	.num {
		font-size: 40px;
		font-weight: 700;
		line-height: 40px;
		text-align: center;
		margin-top: 15px;
		color: #333;
	}

	.name {
		font-size: 14px;
		font-weight: 700;
		color: #333;
		line-height: 14px;
		margin-top: 20px;
		text-align: center;
	}

	.info_title {
		display: inline-block;
		width: 84%;
		font-size: 16px;
		line-height: 16px;
		color: #000000;
		/* font-weight: 700; */
		cursor: pointer;
		text-align: left;
		font-family: "SourceHanSansCn-Medium";
	}

	.info_title:hover {
		color: #009df7;
	}

	.info_time {
		display: inline-block;
		width: 10%;
		text-align: right;
		font-size: 14px;
		line-height: 14px;
		font-weight: 400;
		color: #a1a1a1;
		font-family: "SourceHanSansCn-Medium";
	}

	.info_summary {
		font-size: 14px;
		font-weight: 400;
		color: #888888;
		line-height: 20px;
		margin-top: 12px;
		font-family: "SourceHanSansCn-Medium";
	}

	.listLi {
		color: #999999;
		font-family: "SourceHanSansCn-Medium";
		font-size: 14px;
	}

	.listLi:hover {
		color: #009df7;
	}

	.seeMore {
		font-family: "PingFangSC-Regular";
	}

	.seeMore:hover {
		color: #009ef3 !important;
		text-decoration: underline;
	}
</style>
